import React from 'react';
export function PrivacyContent() {
  return <div className="prose prose-burgundy max-w-none" data-id="element-64">
      <div className="space-y-6 text-burgundy-900" data-id="element-65">
        <section data-id="element-66">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-67">
            1. Información que Recopilamos
          </h3>
          <p className="text-burgundy-800 leading-relaxed mb-3" data-id="element-68">
            Para procesar tu compra, recopilamos únicamente la información
            necesaria:
          </p>
          <ul className="list-disc list-inside space-y-2 text-burgundy-800" data-id="element-69">
            <li data-id="element-70">Nombre y correo electrónico para la entrega del producto</li>
            <li data-id="element-71">
              Información de pago procesada de forma segura por nuestro
              proveedor de pagos
            </li>
            <li data-id="element-72">
              Dirección IP y datos de navegación para prevención de fraude
            </li>
          </ul>
        </section>

        <section data-id="element-73">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-74">
            2. Uso de tu Información
          </h3>
          <p className="text-burgundy-800 leading-relaxed mb-3" data-id="element-75">
            Utilizamos tu información personal únicamente para:
          </p>
          <ul className="list-disc list-inside space-y-2 text-burgundy-800" data-id="element-76">
            <li data-id="element-77">Procesar tu compra y entregar el producto digital</li>
            <li data-id="element-78">Enviar confirmaciones de compra y acceso al contenido</li>
            <li data-id="element-79">Proporcionar soporte al cliente si lo solicitas</li>
            <li data-id="element-80">Cumplir con obligaciones legales y fiscales</li>
          </ul>
          <p className="text-burgundy-800 leading-relaxed mt-3" data-id="element-81">
            <strong data-id="element-82">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros para fines de marketing.
            </strong>
          </p>
        </section>

        <section data-id="element-83">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-84">
            3. Privacidad y Discreción
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-85">
            Entendemos la naturaleza sensible de este producto. Todas las
            comunicaciones y transacciones se manejan con máxima discreción. Los
            correos electrónicos que enviamos utilizan nombres genéricos y no
            revelan el contenido específico del producto.
          </p>
        </section>

        <section data-id="element-86">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-87">
            4. Seguridad de Datos
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-88">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración. Todos los pagos se procesan a través de
            plataformas seguras y encriptadas.
          </p>
        </section>

        <section data-id="element-89">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-90">
            5. Cookies y Tecnologías de Seguimiento
          </h3>
          <p className="text-burgundy-800 leading-relaxed mb-3" data-id="element-91">
            Utilizamos cookies esenciales para:
          </p>
          <ul className="list-disc list-inside space-y-2 text-burgundy-800" data-id="element-92">
            <li data-id="element-93">Mantener tu sesión de compra activa</li>
            <li data-id="element-94">Recordar tus preferencias de idioma</li>
            <li data-id="element-95">Analizar el tráfico del sitio web de forma anónima</li>
          </ul>
          <p className="text-burgundy-800 leading-relaxed mt-3" data-id="element-96">
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar la funcionalidad del sitio.
          </p>
        </section>

        <section data-id="element-97">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-98">
            6. Retención de Datos
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-99">
            Conservamos tu información personal solo durante el tiempo necesario
            para cumplir con los propósitos descritos en esta política, o según
            lo requiera la ley. Los datos de transacciones se mantienen por
            requisitos fiscales y legales.
          </p>
        </section>

        <section data-id="element-100">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-101">7. Tus Derechos</h3>
          <p className="text-burgundy-800 leading-relaxed mb-3" data-id="element-102">
            Tienes derecho a:
          </p>
          <ul className="list-disc list-inside space-y-2 text-burgundy-800" data-id="element-103">
            <li data-id="element-104">Acceder a tu información personal</li>
            <li data-id="element-105">Solicitar corrección de datos inexactos</li>
            <li data-id="element-106">
              Solicitar la eliminación de tus datos (sujeto a obligaciones
              legales)
            </li>
            <li data-id="element-107">Oponerte al procesamiento de tus datos</li>
            <li data-id="element-108">Retirar tu consentimiento en cualquier momento</li>
          </ul>
        </section>

        <section data-id="element-109">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-110">
            8. Comunicaciones por Email
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-111">
            Solo te enviaremos correos relacionados con tu compra y acceso al
            producto. No enviamos newsletters ni comunicaciones de marketing sin
            tu consentimiento explícito.
          </p>
        </section>

        <section data-id="element-112">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-113">
            9. Menores de Edad
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-114">
            Este producto está destinado exclusivamente a adultos mayores de 18
            años. No recopilamos intencionalmente información de menores de
            edad.
          </p>
        </section>

        <section data-id="element-115">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-116">
            10. Cambios a esta Política
          </h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-117">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos por correo electrónico o
            mediante un aviso destacado en nuestro sitio web.
          </p>
        </section>

        <section data-id="element-118">
          <h3 className="text-xl font-serif font-bold mb-3" data-id="element-119">11. Contacto</h3>
          <p className="text-burgundy-800 leading-relaxed" data-id="element-120">
            Si tienes preguntas sobre esta política de privacidad o sobre cómo
            manejamos tu información personal, puedes contactarnos a través de
            los canales proporcionados en nuestro sitio web.
          </p>
        </section>

        <div className="mt-8 pt-6 border-t border-cream-300" data-id="element-121">
          <p className="text-sm text-burgundy-600 italic" data-id="element-122">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </div>
    </div>;
}